module.exports = __webpack_public_path__ + "static/rendering2_mini-2fe7e053475a3e0a3f69258acde0b281.png";